export default {
  namespaced: true,
  state: {
    tabActive: 'home'
  },
  getters: {},
  mutations: {
    setTabActive(state, value) {
      state.tabActive = value
    }
  }
}
